// user 模块的 Vuex store
import api from '@/api/axios'

export default {
  namespaced: true,
  state: {
    // 用户状态
    currentUser: null,
    token: localStorage.getItem('token') || null,
    isAuthenticated: !!localStorage.getItem('token'),
    darkMode: false,
    preferences: {},
    navVisible: true
  },
  mutations: {
    SET_USER(state, user) {
      state.currentUser = user;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    LOGOUT(state) {
      state.currentUser = null;
      state.token = null;
    },
    TOGGLE_DARK_MODE(state) {
      state.darkMode = !state.darkMode;
    },
    SET_NAV_VISIBLE(state, visible) {
      state.navVisible = visible
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
      localStorage.setItem('token', token)
    },
    setUserInfo({ commit }, user) {
      commit('SET_USER', user)
    },
    async login({ commit }, credentials) {
      try {
        const response = await api.post('/users/login', credentials)
        console.log(response)
        if (response.status === 200) {
          commit('SET_USER', response.data.data.user)
          commit('SET_TOKEN', response.data.data.token)
          localStorage.setItem('token', response.data.data.token)
          return response
        } else {
          console.log(response)
          throw new Error('登录失败')
        }
      } catch (error) {
        console.log(error)
        throw error
      }
    },
    async logout({ commit }) {
      commit('LOGOUT')
      localStorage.removeItem('token')
    },
    async register({ commit }, formData) {
      commit('LOGOUT')
      try {
        const response = await api.post('/users/register', formData)
        return response

      } catch (error) {
        console.error('注册失败:', error)
        throw error
      }
    },
    async fetchUser({ commit }) {
      try {
        const response = await api.get('/users/login-by-token')
        // 如果自动登录失败，抛出错误
        if (response.data.status !== 200) {
          console.log('自动登录失败')
          commit('LOGOUT')
          localStorage.removeItem('token')  // 清理localStorage中的token
          throw new Error('自动登录失败')
        }
        console.log(response.data.data)
        commit('SET_USER', response.data.data.user)
        commit('SET_TOKEN', response.data.data.token)
        localStorage.setItem('token', response.data.data.token)
      } catch (error) {
        console.error('获取用户信息失败:', error)
        commit('LOGOUT')
        localStorage.removeItem('token')  // 确保在catch中也清理token
        throw error
      }
    },
    async initializeAuth({ dispatch }) {
      const token = localStorage.getItem('token')
      if (token) {
        try {
          // 尝试使用存储的 token 自动登录
          await dispatch('autoLogin')
        } catch (error) {
          // token 无效或过期，清除本地存储
          localStorage.removeItem('token')
        }
      }
    },
    async autoLogin({ commit }) {
      try {
        const response = await api.get('/users/login-by-token')
        if (response.data.status === 200) {
          commit('SET_USER', response.data.data.user)
          commit('SET_TOKEN', response.data.data.token)
          return true
        }
        return false
      } catch (error) {
        console.error('自动登录失败:', error)
        throw error
      }
    },
    // 用户留言
    async leaveMessage({ commit }, messageData) {
      try {
        const response = await api.post('/users/leave-message', messageData)
        return response
      } catch (error) {
        console.error('留言失败:', error)
        commit('SET_ERROR', error.message || '留言失败')
        throw error
      }
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    currentUser: state => state.currentUser,
    // userLoading: state => false,
    // userError: state => null,
    isDarkMode: state => state.darkMode,
    isNavVisible: state => state.navVisible
  }
}; 